/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandAirtable = createReactComponent("outline", "brand-airtable", "IconBrandAirtable", [["path", { "d": "M3 10v8l7 -3v-2.6z", "key": "svg-0" }], ["path", { "d": "M3 6l9 3l9 -3l-9 -3z", "key": "svg-1" }], ["path", { "d": "M14 12.3v8.7l7 -3v-8z", "key": "svg-2" }]]);

export { IconBrandAirtable as default };
//# sourceMappingURL=IconBrandAirtable.mjs.map
